<template>
  <div class="item-product">
    <router-link :to="'/items/vatpham/' + item.id">
      <img
        :src="baseUrl + item.thumb"
        alt=""
        @error="replaceByDefault">
      <div class="title-product">
        <div 
          v-if="item.name.length > 50"
          class="name-product">{{ item.name.substring(0, 50) + "..." }}</div>
        <div 
          v-else 
          class="name-product">{{ item.name }}</div>
        <div class="price-product">{{ item.price_sale }} đ</div>
      </div>
    </router-link>
  </div>
</template>

<script>
  import ApiConfig from "../../communicate/ApiConfig";
  import defaultImage from '../../assets/images/default.png';

  export default {
    name: "ProductItem",
    props: ["item"],
    data: function () {
      return {
        baseUrl: ApiConfig.base_url
      }
    },
    methods: {
      replaceByDefault(e) {
        e.target.src = defaultImage;
      }
    }
  }
</script>

<style scoped>
  .item-product {
    height: 100%;
    width: 100%;
    position: relative;
    cursor: pointer;
    border: 1px solid #efefef;
    border-radius: 4px;
  }

  .item-product img {
    height: 142px;
    max-height: 160px;
    width: 100%;
    border-radius: 5px 5px 0 0;
    border-bottom: 1px solid #efefef;
  }

  .title-product {
    background: white;
    width: 100%;
    padding: 8px;
  }

  .title-product .name-product {
    font-weight: bold;
    font-size: 0.8rem;
    color: #000;
  }

  .title-product .price-product {
    font-weight: bold;
    color: #FF595A;
    font-size: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/categories/ProductItem.vue